/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '../router/index.js';
import firebase from 'firebase';

Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  const result = originalPush.call(
    this,
    location,
    onComplete,
    onAbort
  );
  if (result) {
    return result.catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
  return result;
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  const result = originalReplace.call(
    this,
    location,
    onComplete,
    onAbort
  );
  if (result) {
    return result.catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
  return result;
};

export const router = new VueRouter({
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const user = firebase.auth().currentUser;

  const url = new URL(window.location.href.replace('#', ''));
  const invite_token = url.searchParams.get('token');
  const invite_project = url.searchParams.get('project');

  if (invite_token && invite_project) {
    sessionStorage.setItem('invite_token', invite_token);
    sessionStorage.setItem('invite_project', invite_project);
    sessionStorage.removeItem('is_block');

  }

  if (to.matched.some(m => m.meta.auth) && !user) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: 'Authorization-index',
    });
  } else if (to.matched.some(m => m.meta.guest) && user) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: 'infoView',
    });
  } else {
    next();
  }
});

Vue.router = router;

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/plugins/router.js